import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import MessagesAdmin from './MessagesAdmin';
import NamesAdmin from './NamesAdmin';
import AnalyticsDashboard from './AnalyticsDashboard';
import HistoryView from './HistoryView';

type TabType = 'messages' | 'names' | 'analytics' | 'history';

const AdminPanel: React.FC = () => {
  const [activeTab, setActiveTab] = useState<TabType>('messages');
  const { logout } = useAuth();

  const handleLogout = () => {
    // eslint-disable-next-line no-restricted-globals
    if (confirm('Êtes-vous sûr de vouloir vous déconnecter ?')) {
      logout();
      window.location.href = '/';
    }
  };

  const tabs = [
    { id: 'messages' as TabType, label: 'Messages', icon: '💬' },
    { id: 'names' as TabType, label: 'Noms', icon: '👤' },
    { id: 'analytics' as TabType, label: 'Analytics', icon: '📊' },
    { id: 'history' as TabType, label: 'Historique', icon: '📅' },
  ];

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="max-w-7xl mx-auto">
        {/* Header avec boutons retour et déconnexion */}
        <div className="flex justify-between items-center mb-8">
          <h1 className="text-3xl font-bold text-gray-900">Panel d'Administration</h1>
          <div className="flex space-x-4">
            <Link
              to="/"
              className="bg-gradient-to-r from-gray-500 to-gray-600 text-white font-bold py-2 px-4 rounded-full hover:from-gray-600 hover:to-gray-700 transition duration-300 shadow-lg hover:shadow-xl"
            >
              ← Retour à l'application
            </Link>
            <button
              onClick={handleLogout}
              className="bg-gradient-to-r from-red-500 to-red-600 text-white font-bold py-2 px-4 rounded-full hover:from-red-600 hover:to-red-700 transition duration-300 shadow-lg hover:shadow-xl"
            >
              🚪 Déconnexion
            </button>
          </div>
        </div>
        
        {/* Navigation */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 mb-6">
          <nav className="flex space-x-8 px-6" aria-label="Tabs">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`${
                  activeTab === tab.id
                    ? 'border-blue-500 text-blue-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                } whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm flex items-center space-x-2 transition-colors`}
              >
                <span className="text-lg">{tab.icon}</span>
                <span>{tab.label}</span>
              </button>
            ))}
          </nav>
        </div>

        {/* Contenu des onglets */}
        <div className={`${activeTab === 'analytics' ? '' : 'bg-white rounded-lg shadow-sm border border-gray-200'}`}>
          {activeTab === 'messages' && <MessagesAdmin />}
          {activeTab === 'names' && <NamesAdmin />}
          {activeTab === 'analytics' && <AnalyticsDashboard />}
          {activeTab === 'history' && (
            <div className="p-6">
              <HistoryView />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminPanel;
